import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/cost-center-list.component.html',
})
export class CostCenterListComponent1 implements OnInit {
  @Input()
  ACC_NO: any;

  @Input()
  modalShow: boolean = true;

  @Input()
  selectCostCenterForCostCenterForCR;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;
  costCenterList: any[] = [];
  searchFields: any[] = ['COST_NAME', 'COST_NO'];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "CostCenterListqGrid"
  public searchString;
  constructor(private dataService: CommonService,
    public langService: LangService,
    public gridService:GridService) {
      this.colObj = [
        { headerName: langService.langData.costCenter, field: 'COST_NAME', sortable: true, resizable: true, hide: false },
        { headerName: langService.langData.costNo, field: 'COST_NO', sortable: true, resizable: true, hide: false }
      ];
     }

     ngOnInit() {
      this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
  
    onGridReady(grid) {
      this.grid = grid;
      this.gridService.sizeColumnsToFit(grid, this.gridId); 
     
      if(this.selectCostCenterForCostCenterForCR){
        this.dataService.getCostCenters(this.selectCostCenterForCostCenterForCR)
        .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
      }
      else if (this.selectCostCenterForCostCenterForCR) {
        this.dataService.getCostCenters(fixedValues.queryOptions.CostCenterForCR)
          .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
      }else {
      this.dataService.getCostCenters(fixedValues.queryOptions.CostCenterDtl, this.ACC_NO)
        .subscribe(arg => { console.log(arg); this.costCenterList = arg.body });
      }
    }
    itemClick(_item) {
      this.modalShow = false; 
      this.dataObj=_item;
      this.submit.next();
    }

}
